export enum RolesUser {
  // Руководитель HR
  HRDirector = 'HRDirector',
  // 1 линия
  FirstLine = 'FirstLine',
  // 2 линия
  SecondLine = 'SecondLine',
  // Группа консультаций
  Consultant = 'Consultant',
  // Сотрудник
  Employee = 'Employee',
}

export const RolesToRussian: Record<RolesUser, string> = {
  [RolesUser.HRDirector]: 'Руководитель HR',
  [RolesUser.FirstLine]: '1 линия',
  [RolesUser.SecondLine]: '2 линия',
  [RolesUser.Consultant]: 'Группа консультаций',
  [RolesUser.Employee]: 'Сотрудник',
};
